module.exports = __webpack_public_path__ + "img/poster_id_pp.51227452.png";